export default __webpack_public_path__ + "static/media/icon__map-marker.bdd2eb5c.svg";